import React, { Fragment } from "react";
import {
  CheckBox,
  PhotoCamera,
  SettingsRemote,
  Gesture,
  MenuOpen,
  TextFormat,
  Edit,
  Delete,
} from "@material-ui/icons";

export enum IconEnum {
  BARCODE = "BARCODE",
  SIGNATURE = "SIGNATURE",
  EDIT = "EDIT",
  DELETE = "DELETE",
  ADD = "ADD",
  PHOTO = "PHOTO",
  CHECKLIST = "CHECKLIST",
  DROPDOWN = "DROPDOWN",
  FORM = "FORM",
}

interface IconProps {
  iconEnum: IconEnum;
}

export default function Icon({ iconEnum }: IconProps) {
  let icon = <div>N/A</div>;
  switch (iconEnum) {
    case IconEnum.BARCODE:
      icon = <SettingsRemote />;
      break;
    case IconEnum.CHECKLIST:
      icon = <CheckBox />;
      break;
    case IconEnum.FORM:
      icon = <TextFormat />;
      break;
    case IconEnum.DROPDOWN:
      icon = <MenuOpen />;
      break;
    case IconEnum.SIGNATURE:
      icon = <Gesture />;
      break;
    case IconEnum.PHOTO:
      icon = <PhotoCamera />;
      break;
    case IconEnum.ADD:
      icon = <PhotoCamera />;
      break;
    case IconEnum.EDIT:
      icon = <Edit />;
      break;
    case IconEnum.DELETE:
      icon = <Delete />;
      break;
  }
  return <Fragment>{icon}</Fragment>;
}
